import styled from 'styled-components'

export const HeroImageStyled = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
`
